"use client";

import { type ReactNode, createContext, useRef, useContext } from "react";
import { useStore } from "zustand";

import { type TourStore, createTourStore } from "@/stores/tour-store/TourStore";

export type TourStoreApi = ReturnType<typeof createTourStore>;

export const TourStoreContext = createContext<TourStoreApi | undefined>(
  undefined,
);

export interface TourStoreProviderProps {
  children: ReactNode;
}

export const TourStoreProvider = ({ children }: TourStoreProviderProps) => {
  const storeRef = useRef<TourStoreApi | null>(null);
  if (!storeRef.current) {
    storeRef.current = createTourStore();
  }

  return (
    <TourStoreContext.Provider value={storeRef.current}>
      {children}
    </TourStoreContext.Provider>
  );
};

export const useTourStore = <T,>(selector: (store: TourStore) => T): T => {
  const tourStoreContext = useContext(TourStoreContext);

  if (!tourStoreContext) {
    throw new Error(`useTourStore must be used within CounterStoreProvider`);
  }

  return useStore(tourStoreContext, selector);
};
